import script from "./SecondaryColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondaryColumn.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__